import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../animation/counter.js';

gsap.registerPlugin(ScrollTrigger);

export default class InfographicAnim {
  constructor(section) {
    this.section = section;
		this.bgkPicture = this.section.querySelector(".bgk-img");
		this.infoBoxes = [...this.section.querySelectorAll(".stat-content")];
		this.numbers = [...this.section.querySelectorAll(".inner-content .stat-number")];
		this.descriptions = [...this.section.querySelectorAll(".inner-content .stat-description")];

		this.isMobile = !window.matchMedia('(min-width: 1024px)').matches;

		if (!this.isMobile) {
			this.scaleGutter();
		}
    this.init();
  }

	scaleGutter() {
		this.infoBoxes.forEach(box => {
			const gutterWidth = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--gutter'));
			const viewportWidth = window.innerWidth;

			const scaleX = viewportWidth / gutterWidth;

			gsap.set(box, {
				'--before-scale-x': scaleX,
			});
		});
	}

	init() {
		document.fonts.ready.then(() => {

			this.tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.section,
					start: "top 70%",
					once: true
				},
				defaults: {force3D: true},
			});

			if (this.isMobile) {
				this.tl
					.set(this.infoBoxes, {
						'--before-scale-x': 1,
					}, 0)
					.set(this.numbers, {
						marginLeft: 0,
						opacity: 1,
					}, 0)
					.counter(this.numbers, {
						duration: 0.8,
						increment: 1,
						stagger: 0.3,
						ease: "linear"
					}, 0)
					.set(this.descriptions, {
						opacity: 1,
					}, 0);
			} else {
				// Desktop: animazione barra bianca scaleX originale
				this.tl
					.to(this.infoBoxes, {
						'--before-scale-x': 1,
						duration: 0.8,
						stagger: 0.3
					}, 0)
					.to(this.bgkPicture, {
						filter: "blur(0px)",
						duration: 0.8,
					}, 0)
					.to(this.numbers, {
						marginLeft: 0,
						opacity: 1,
						duration: 0.8,
						stagger: 0.3
					}, 0.7)
					.counter(this.numbers, {
						duration: 0.8,
						increment: 1,
						stagger: 0.3,
						ease: "linear"
					}, 1)
					.to(this.descriptions, {
						opacity: 1,
						duration: 0.8,
						stagger: 0.3
					}, 0.7);
			}

		});

		return this.tl;

  }
}